import { TRecommendation } from '../../types/recommendation';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EAnalyticsActionTypes {
  SetProducts = 'analytics/set_products',
}

export type TSetAnalyticsProducts = ITypedReduxAction<EAnalyticsActionTypes.SetProducts, TRecommendation[]>;

export type TAnalyticsActions = TSetAnalyticsProducts;
